import './styles.scss'
import React from 'react'
import { Collapse } from 'reactstrap'
import ReactTooltip from 'react-tooltip'
import { I18n } from 'react-redux-i18n'

import { DotsOptionsSelector } from 'components/common'
import { Button } from 'components/Form'
import ActionCard from '../ActionCard'
import { getStaticImage } from 'utils/statics'

const ProcessContainerUI = ({
  data,
  isOpenOptionsSelector,
  toggleOptionsSelector,
  toggleActionModal,
  toggleDeleteActionModal,
  toggleCopyContainerModal,
  toggleDeleteContainerModal,
  onChangeSmartChatCollapse,
  isCollapsed,
  isDisabled
}) => (
  <div className='process-content__actions-container'>
    <strong className='process-content__title'>{I18n.t('dashboard_events')}</strong>
    <div className='process-content__options'>
      <figure
        className='wrapper-exp pointer'
        onClick={() => onChangeSmartChatCollapse({ containerType: data.containerType, containerId: data.containerId })}
      >
        {isCollapsed ? (
          <img src={getStaticImage('/icons/orange-brand/icon-collapse.svg')} alt='Collapse' height={22} />
        ) : (
          <img src={getStaticImage('/icons/orange-brand/icon-expand2.svg')} alt='Expand' height={22} />
        )}
      </figure>
      <DotsOptionsSelector
        isOpen={isOpenOptionsSelector}
        toggle={toggleOptionsSelector}
        options={['onNewProcess', 'onLeaveProcess'].includes(data.containerType) ? [
          {
            name: I18n.t('dashboard_copy-another-process'),
            onClick: () => toggleCopyContainerModal(data)
          }
        ] : [
          {
            name: I18n.t('dashboard_delete'),
            onClick: () => toggleDeleteContainerModal(data)
          },
          {
            name: I18n.t('dashboard_copy-another-process'),
            onClick: () => toggleCopyContainerModal(data)
          }
        ]}
        position='top'
      />
    </div>
    <p className='process-content__container-title'>{data.containerName}</p>
    <div className='process-content__tags-container'>
      {['onNewProcess', 'onLeaveProcess'].includes(data.containerType) && (
        <div className='process-content__optional-tag'>
          <span>{I18n.t('dashboard_optional')}</span>
        </div>
      )}
      <div className='process-content__tooltip'>
        <i className='fa fa-info-circle fa-info-circle--smartchat' aria-hidden='true' data-for={`tooltip-${data.containerType}`} data-tip={data.containerType === 'onProcess' ? I18n.t('smartchat_container_tooltip_process') : I18n.t('smartchat_container_tooltip_optionalProcess')}></i>
        <ReactTooltip id={`tooltip-${data.containerType}`} effect='solid' html={true} />
      </div>
    </div>
    <Collapse isOpen={isCollapsed} className='process-content__actions-content'>
      {['onNewProcess', 'onLeaveProcess'].includes(data.containerType) && (
        <div className='process-content__bot-actions'>
          {data.actionList.length ? (
            data.actionList.map((action, actionIndex) => (
              <ActionCard
                key={actionIndex}
                actionDetail={action}
                modalActionRef={{
                  type: 'bot',
                  actionType: 'botAction',
                  containerType: data.containerType,
                  actionIndex
                }}
                toggleActionModal={toggleActionModal}
                toggleDeleteActionModal={toggleDeleteActionModal}
              />
            ))
          ) : (
            <p className='not-found-text'>{I18n.t('chatbot_container_text_addAction')}</p>
          )}
          <Button
            container
            containerPrimary
            value={I18n.t('chatbot_button_addBotAction')}
            onClick={() => toggleActionModal({
              mode: 'add',
              type: 'bot',
              actionType: 'botAction',
              containerType: data.containerType
            })}
          />
        </div>
      )}

      {data.containerType === 'onProcess' && (
        <div className='process-content__actions'>
          {data.actionList.length ? (
            data.actionList.map((action, actionIndex) => (
              <div key={actionIndex} className='process-content__client-operator-actions'>
                <ActionCard
                  actionDetail={action}
                  modalActionRef={{
                    type: ['customerAction', 'transactionalAction'].includes(action.actionType) ? 'customer' : 'operator',
                    actionType: action.actionType,  // customerAction / transactionalAction / operatorAction / backendAction
                    containerType: data.containerType,
                    containerId: data.containerId,
                    actionIndex
                  }}
                  toggleActionModal={toggleActionModal}
                  toggleDeleteActionModal={toggleDeleteActionModal}
                />
                {action.botActionList.map((botAction, botActionIndex) => (
                  <ActionCard
                    key={botActionIndex}
                    actionDetail={botAction}
                    modalActionRef={{
                      type: 'bot',
                      actionType: 'botAction',
                      containerType: data.containerType,
                      containerId: data.containerId,
                      actionIndex: botActionIndex,
                      fromActionType: action.actionType,  // customerAction / transactionalAction / operatorAction / backendAction
                      fromAction: action.actionSubtype,
                      fromActionIndex: actionIndex
                    }}
                    toggleActionModal={toggleActionModal}
                    toggleDeleteActionModal={toggleDeleteActionModal}
                  />
                ))}
                <Button
                  container
                  containerPrimary
                  value={I18n.t('chatbot_button_addBotAction')}
                  onClick={() => toggleActionModal({
                    mode: 'add',
                    type: 'bot',
                    actionType: 'botAction',
                    containerType: data.containerType,
                    containerId: data.containerId,
                    fromActionType: action.actionType,  // customerAction / transactionalAction / operatorAction / backendAction
                    fromAction: action.actionSubtype,
                    fromActionIndex: actionIndex
                  })}
                />
              </div>
            ))
          ) : (
            <p className='not-found-text'>{I18n.t('chatbot_container_text_addAction')}</p>
          )}
          <div className='process-content__client-operator-buttons'>
            <Button
              light
              icon={<i className="fa fa-plus-circle"></i>}
              className='col-sm-auto'
              value={I18n.t('chatbot_button_addCustomerAction')}
              onClick={() => toggleActionModal({
                mode: 'add',
                type: 'customer',
                containerType: data.containerType,
                containerId: data.containerId
              })}
              disabled={isDisabled}
            />
            <Button
              light
              icon={<i className="fa fa-plus-circle"></i>}
              className='col-sm-auto'
              value={I18n.t('chatbot_button_addOperatorAction')}
              onClick={() => toggleActionModal({
                mode: 'add',
                type: 'operator',
                containerType: data.containerType,
                containerId: data.containerId
              })}
              disabled={isDisabled}
            />
          </div>
        </div>
      )}
    </Collapse>
  </div>
)

export default ProcessContainerUI
